import axios from 'axios'
import React, {useCallback, useState} from 'react'
import {AsyncTypeahead} from 'react-bootstrap-typeahead'
import {Response} from '../../../../_metronic/helpers'
import {TypeAheadCollection, TypeAheadResponse} from '../../../_apiModels/_libraryModels'
import {MODAL_TYPES, useMessageModalContext} from '../../utilities'

const CACHE: any = {}
const PER_PAGE = 50
const API_URL = process.env.REACT_APP_API_URL

type Props = {
  displayText: string
  formik: any
  field: string
  apiEndpoint: string
  onChange?: () => void
  singleSelect?: boolean

}

function makeAndHandleRequest(query: string, apiEndpoint: string, page = 1) {
  return axios
    .get<TypeAheadResponse>(`${API_URL}${apiEndpoint}${query}`)
    .then((response: Response<TypeAheadResponse>) => {
      return response.data
    })
}

export const AncientTypeAhead: React.FC<Props> = ({displayText, formik, field, apiEndpoint, singleSelect = false}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [options, setOptions] = useState<Array<TypeAheadCollection>>([])
  const [query, setQuery] = useState<string>('')
  const {showModal} = useMessageModalContext()

  const handleInputChange = (q: string) => {
    setQuery(q)
  }

  const handlePagination = (e: any, shownResults: number) => {
    const cachedQuery = CACHE[query]

    // Don't make another request if:
    // - the cached results exceed the shown results
    // - we've already fetched all possible results
    if (
      cachedQuery.collectionList.length > shownResults ||
      cachedQuery.collectionList.length === cachedQuery.total_count
    ) {
      return
    }

    setIsLoading(true)

    const page = cachedQuery.page + 1

    makeAndHandleRequest(query, page).then((resp: any) => {
      const collection = cachedQuery.collectionList.concat(resp.collectionList)
      CACHE[query] = {...cachedQuery, collection, page}

      setIsLoading(false)
      setOptions(collection)
    })
  }

  // `handleInputChange` updates state and triggers a re-render, so
  // use `useCallback` to prevent the debounced search handler from
  // being cancelled.
  const handleSearch = useCallback((q) => {
    if (CACHE[q]) {
      setOptions(CACHE[q].collectionList)
      return
    }

    setIsLoading(true)
    makeAndHandleRequest(q, apiEndpoint).then((resp: any) => {
      CACHE[q] = {...resp, page: 1}

      setIsLoading(false)
      setOptions(resp.collectionList)
    })
  }, [])

  const handleSelect = (items: any) => {
    if (items?.[0] === undefined || !items?.length) {
      return
    }
    const itemList = formik.values[field]
    const {id, label} = items[0]
    const isItemAlreadySelected = itemList.some((item: any) => item.id === id)
    if (isItemAlreadySelected) {
      showModal(MODAL_TYPES.WARNING_TOAST, {message: 'Company is already assigned.'})
      return
    }
    
    ///TODO: "companyName" needs to be more generic as the descriptor. Curerntly only used for company profile.
    const companyItem = {id: id, companyName: label, label: label}
    formik.setFieldValue(field, [...itemList, companyItem])
  }

  return (
    <div className='row mb-6'>
      <div className='input-group'>
        <AsyncTypeahead
          id='async-pagination-example'
          isLoading={isLoading}
          maxResults={PER_PAGE - 1}
          minLength={2}
          onInputChange={handleInputChange}
          onPaginate={handlePagination}
          onSearch={handleSearch}
          onChange={handleSelect}
          selected={[]}
          options={options}
          paginate={false}
          placeholder={displayText}
          useCache={false}
          className='m0'
          disabled={singleSelect && formik.values[field]?.length > 0}

        />
      </div>
    </div>
  )
}
